import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { ScrollIntoView, Alert, RichTextArea, Button } from '@grandvisionhq/common';
import { Heading, Divider, Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import SignUpForm from '../../components/SignUpForm/SignUpForm.js';
import { SocialLogin } from '../../components/SocialLogin/SocialLogin.js';

const SignUp = ({ labels , onFormSubmit , onSocialLogin , optIns , termsRichText , signupError , hasProviders  })=>{
    var ref;
    const { href: loginUrl  } = (ref = useLink({
        route: 'auth.login'
    })) !== null && ref !== void 0 ? ref : {};
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const signupPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return swcHelpers.objectSpread({
            id: 'VirtualPage-View',
            Page_Section1: 'Account',
            Page_Type: 'Login&Register',
            Page_Design: 'Register'
        }, commonEventProperties, commonUserProperties);
    }), [
        commonEventProperties,
        getCommonUserProperties
    ]);
    useTrackPageView(signupPageView);
    return /*#__PURE__*/ React.createElement("div", {
        className: "signup"
    }, /*#__PURE__*/ React.createElement("section", {
        className: "signup__signup-section"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: hasProviders ? 'small' : 'medium',
        className: "signup__title"
    }, labels.signup.title), hasProviders && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SocialLogin, {
        onLogin: onSocialLogin,
        labels: labels.social
    }), /*#__PURE__*/ React.createElement(Divider, {
        className: "signup__divider",
        caption: labels.or
    }), /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        className: "signup__title"
    }, labels.emailSignup)), signupError && /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: signupError
    }, /*#__PURE__*/ React.createElement(Alert, {
        type: "error",
        icon: "info",
        message: signupError
    })), /*#__PURE__*/ React.createElement(SignUpForm, {
        "data-t": "signup-form",
        onSubmit: onFormSubmit,
        renderOptIns: optIns,
        buttonLabel: labels.actions.createAccount,
        buttonClass: "signup__button"
    }, termsRichText && /*#__PURE__*/ React.createElement("div", {
        className: "signup__terms"
    }, /*#__PURE__*/ React.createElement(RichTextArea, {
        content: termsRichText
    }))), labels.dataConsent && /*#__PURE__*/ React.createElement(Text, {
        className: "signup__data-processing-disclaimer",
        variant: "caption"
    }, labels.dataConsent)), /*#__PURE__*/ React.createElement("section", {
        className: "signup__login-section"
    }, /*#__PURE__*/ React.createElement(Heading, {
        component: "h2",
        variant: "small"
    }, labels.hasAccount.title), /*#__PURE__*/ React.createElement("p", {
        className: "signup__login-text"
    }, labels.hasAccount.text), /*#__PURE__*/ React.createElement(Button, {
        className: "signup__login-button",
        caption: labels.actions.login,
        variant: "outline",
        "data-t": "to-login",
        href: loginUrl
    })));
};

export { SignUp, SignUp as default };
//# sourceMappingURL=SignUp.js.map
